<template>
  <CContainer fluid>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>Files Manager - Categories</CCardHeader>
          <CCardBody>
            <p class="text-muted">
              Inventory of images stored under <code>public/files/*</code>. Click a category to
              inspect individual files and filter by size, format, or usage.
            </p>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Files</th>
                    <th>Total Size</th>
                    <th>Formats</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in categories" :key="row.category">
                    <td>{{ row.label }}</td>
                    <td>{{ row.file_count }}</td>
                    <td>{{ formatBytes(row.total_size) }}</td>
                    <td>
                      <CBadge
                        v-for="(count, format) in row.formats"
                        :key="format"
                        color="secondary"
                        class="mr-1"
                      >
                        {{ format || 'n/a' }}: {{ count }}
                      </CBadge>
                    </td>
                    <td>
                      <CButton color="info" size="sm" @click="openCategory(row.category)">
                        View Files
                      </CButton>
                    </td>
                  </tr>
                  <tr v-if="categories.length === 0">
                    <td colspan="5" class="text-center">Loading...</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import devService from '@/services/dev'

export default {
  data() {
    return {
      categories: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      devService.getFilesManagerCategories()
        .then((res) => {
          this.categories = res.data || []
        })
        .catch((err) => {
          alert((err.response && err.response.data && err.response.data.message) || 'Failed to load categories')
        })
    },
    openCategory(category) {
      this.$router.push('/dev_page/files-manager/' + category)
    },
    formatBytes(bytes) {
      if (!bytes) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let i = 0
      let value = bytes
      while (value >= 1024 && i < units.length - 1) {
        value /= 1024
        i++
      }
      return value.toFixed(i === 0 ? 0 : 1) + ' ' + units[i]
    }
  }
}
</script>
